/**
 * Componente para configurar gravação de chamadas
 * VigosCloud - Incoming Call System
 * 
 * Reutilizável para configurar gravação em qualquer fluxo de chamada
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faRecordVinyl
} from '@fortawesome/free-solid-svg-icons';

function RecordingConfiguration({ 
  config = {
    recording_enabled: false,
    recording_format: 'wav',
    protocol_callerid_enabled: false
  },
  onChange,
  disabled = false,
  title = 'Gravação de Chamadas'
}) {

  const recordingFormats = [
    { 
      value: 'wav', 
      label: 'WAV', 
      description: 'Alta qualidade, maior tamanho',
      extension: '.wav'
    },
    { 
      value: 'mp3', 
      label: 'MP3', 
      description: 'Boa qualidade, tamanho médio',
      extension: '.mp3'
    },
    { 
      value: 'gsm', 
      label: 'GSM', 
      description: 'Qualidade média, menor tamanho',
      extension: '.gsm'
    }
  ];

  const handleChange = (field, value) => {
    if (onChange) {
      onChange({
        ...config,
        [field]: value
      });
    }
  };

  const handleProtocolCalleridChange = (checked) => {
    if (disabled || !config.recording_enabled) return;
    handleChange('protocol_callerid_enabled', checked);
  };

  return (
    <div className="box" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h3 className="title is-5 mb-4">
        <FontAwesomeIcon icon={faRecordVinyl} className="mr-2" />
        {title}
      </h3>

      <div className="field">
        <label className="checkbox">
          <input
            type="checkbox"
            checked={config.recording_enabled || false}
            onChange={(e) => handleChange('recording_enabled', e.target.checked)}
            disabled={disabled}
          />
          <span className="ml-2">
            <FontAwesomeIcon icon={faRecordVinyl} className="mr-2" />
            Gravar chamadas
          </span>
        </label>
        <p className="help">
          Se habilitado, todas as chamadas que passarem por esta configuração serão gravadas
        </p>
      </div>

      <div className="field">
        <label className="checkbox">
          <input
            type="checkbox"
            checked={config.protocol_callerid_enabled || false}
            onChange={(e) => handleProtocolCalleridChange(e.target.checked)}
            disabled={disabled || !config.recording_enabled}
          />
          <span className="ml-2">Enviar protocolo na chamada</span>
        </label>
        <p className="help">
          {config.recording_enabled
            ? 'O protocolo substitui o nome do chamador no identificador do atendente, inclusive no Callcenter V2 e nas integrações.'
            : 'Requer gravação habilitada'}
        </p>
      </div>

      {config.recording_enabled && (
        <div>
          <div className="field is-hidden">
            <label className="label">Formato de Gravação *</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select
                  value={config.recording_format || 'wav'}
                  onChange={(e) => handleChange('recording_format', e.target.value)}
                  disabled={disabled}
                >
                  {recordingFormats.map(format => (
                    <option key={format.value} value={format.value}>
                      {format.label} - {format.description}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Informações sobre o formato selecionado */}
          <div className="box has-background-white-ter is-hidden">
            <div className="content is-small">
              <p className="heading">Informações do Formato Selecionado</p>
              {recordingFormats.map(format => (
                config.recording_format === format.value && (
                  <div key={format.value}>
                    <div className="level is-mobile mb-2">
                      <div className="level-left">
                        <div className="level-item">
                          <strong>Formato:</strong>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          <span className="tag is-info">{format.label}</span>
                        </div>
                      </div>
                    </div>
                    <div className="level is-mobile mb-2">
                      <div className="level-left">
                        <div className="level-item">
                          <strong>Extensão:</strong>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          <code>{format.extension}</code>
                        </div>
                      </div>
                    </div>
                    <div className="level is-mobile">
                      <div className="level-left">
                        <div className="level-item">
                          <strong>Descrição:</strong>
                        </div>
                      </div>
                      <div className="level-right">
                        <div className="level-item">
                          {format.description}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecordingConfiguration;

